import React from 'react';
import SectionTitle2 from '../../sectionTitle/SectionTitle2';
import { Element } from 'react-scroll';
import { Link } from 'react-router-dom';

const CaseStudy = () => {
  const outcome1 = "✓";
  const outcome2 = "✓";
  const outcome3 = "✓";
  const outcome4 = "✓";

  return (
    <>
      <Element
        name="CaseStudy"
        className="datatalent-section-gap mea-key-features"
      >
        <div className="container inner about-feature-list">
          <div className="row g-5">
            <div className="col-12 mt-0 px-0 px-md-4">
              <SectionTitle2
                classes = "text-center"
                title = "Case Study"
              />
            </div>
            <div className="col-12 mt-4 px-0 px-md-4">
              {/* <p className="text-center">How we helped a precision manufacturing company embrace Industry 4.0.</p> */}
            </div>
            <div className="single-case-study-card d-flex flex-column flex-md-row align-items-center justify-content-between bg-white p-4 p-md-5">
              <div className="col-12 col-md-8">
                <div className="d-flex flex-row align-items-center justify-content-start gap-4">
                  <div className="icon-image-box h-100">
                    <img src={`${process.env.PUBLIC_URL}/images/icons/factory.svg`} alt="factory" />
                  </div>
                  <div className="title-and-subtitle">
                    <h5 className="mb-0 lh-1">Bayes Studio</h5>
                    <p className="mb-0">Wildfire Prediction Platform for Bayes Studio</p>
                  </div>
                </div>
                <h6 className="mt-5 mb-4">The Challenge</h6>
                <p>Bayes Studio sought to improve wildfire prediction accuracy to reduce risks to infrastructure and ecosystems. Traditional vegetation mapping and manual risk assessments lacked predictive capability and spatial detail.</p>
                <h6 className="mb-4">Our Approach</h6>
                <p className="mb-0">M2M Tech supported the development of an AI-driven framework using satellite imagery, weather, and wildfire history. Our team built a data pipeline for vegetation classification and combined it with environmental factors to build a robust multi-dimensional dataset. This enabled the training of AI models for wildfire prediction.</p>
                <h6 className="mt-5 mb-4">Key Results</h6>
                <ul>
                  <li>High-resolution vegetation analysis using satellite imagery</li>
                  <li>Integrated real-time weather and historical wildfire data</li>
                  <li>Foundation for scalable, predictive wildfire risk modeling</li>
                  <li>AI models embedded into visual dashboards for live monitoring</li>
                </ul>
                <h6 className="mb-4">Impact</h6>
                <p className="mb-0">Bayes Studio now offers proactive wildfire risk assessment services for energy utilities and municipalities, reducing their exposure to natural disaster threats.</p>
              </div>
              <div className="col-12 col-md-4 mt-4 md-mt-0">
                <div className="single-case-study-stats ms-md-4 p-4 p-md-5">
                  <h6>Key Outcomes</h6>
                  <div className="d-flex flex-row align-items-center justify-content-between">
                    <small>Live Risk Dashboards</small>
                    <small>{outcome1}</small>
                  </div>
                  <div className="case-study-progress-bar">
                    <div className="reduced-downtime-progress" style={{width: outcome1}}></div>
                  </div>
                  <div className="d-flex flex-row align-items-center justify-content-between mt-3">
                    <small>Weather + Wildfire History</small>
                    <small>{outcome2}</small>
                  </div>
                  <div className="case-study-progress-bar">
                    <div className="quality-improvement-progress" style={{width: outcome2}}></div>
                  </div>
                  <div className="d-flex flex-row align-items-center justify-content-between mt-3">
                    <small>AI Risk Modeling</small>
                    <small>{outcome3}</small>
                  </div>
                  <div className="case-study-progress-bar">
                    <div className="oee-increase-progress" style={{width: outcome3}}></div>
                  </div>
                  <div className="d-flex flex-row align-items-center justify-content-between mt-3">
                    <small>Vegetation Mapping</small>
                    <small>{outcome4}</small>
                  </div>
                  <div className="case-study-progress-bar">
                    <div className="roi-timeline-progress" style={{width: outcome4}}></div>
                  </div>
                    <Link className="edu-btn btn-primary btn-small w-100 text-center mt-5" to="/contact-us">Request Full Case Study</Link>
                  </div>
              </div>
            </div>
          </div>
        </div>
      </Element>
    </>
  )
}

export default CaseStudy;